"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Constants = void 0;
class Constants {
}
exports.Constants = Constants;
Constants.MosActionId = "actionId";
Constants.MosIcons = "icons";
Constants.MosType = "type";
Constants.MosV100 = "1.0";
Constants.MosV101 = "1.1";
Constants.MosView = "view";
Constants.MosManifestGAVersion_1_17 = "1.17";
Constants.$Schema = "$schema";
Constants.MosManifestSchemaVersionDevPreview = "https://developer.microsoft.com/json-schemas/teams/vDevPreview/MicrosoftTeams.schema.json#";
Constants.MosManifestLocalizationSchemaVersionDevPreview = "https://developer.microsoft.com/json-schemas/teams/vDevPreview/MicrosoftTeams.Localization.schema.json#";
Constants.MosManifestSchemaVersionDevPreviewOld = "https://raw.githubusercontent.com/OfficeDev/microsoft-teams-app-schema/preview/DevPreview/MicrosoftTeams.schema.json#";
Constants.MosManifestSchemaVersionGA = "https://developer.microsoft.com/json-schemas/teams/v1.17/MicrosoftTeams.schema.json#";
Constants.MosManifestLocalizationSchemaVersionGA = "https://developer.microsoft.com/json-schemas/teams/v1.17/MicrosoftTeams.Localization.schema.json#";
Constants.DocumentRestrictedUser = "Document.Restricted.User";
Constants.DocumentReadAllUser = "Document.ReadAll.User";
Constants.DocumentReadUser = "Document.Read.User";
Constants.DocumentReadWriteUser = "Document.ReadWrite.User";
Constants.DocumentWriteUser = "Document.Write.User";
Constants.MailboxAccessSharedFoldersUser = "Mailbox.AccessSharedFolders.User";
Constants.MailboxItemAppendOnSendUser = "MailboxItem.AppendOnSend.User";
Constants.MailboxItemRestrictedUser = "MailboxItem.Restricted.User";
Constants.MailboxItemReadUser = "MailboxItem.Read.User";
Constants.MailboxItemReadWriteUser = "MailboxItem.ReadWrite.User";
Constants.MailboxReadWriteUser = "Mailbox.ReadWrite.User";
Constants.InputAction = "action";
Constants.InputActionId = "actionId";
Constants.InputAddinCommandsExtensionPoints = "_addinCommandsExtensionPoints";
Constants.InputAppendOnSend = "AppendOnSend";
Constants.InputAppointmentOrganizerCommandSurface = "AppointmentOrganizerCommandSurface";
Constants.InputAppointmentAttendeeCommandSurface = "AppointmentAttendeeCommandSurface";
Constants.InputAutoRunExtensionPoint = "AutoRunExtensionPoint";
Constants.InputButton = "Button";
Constants.InputChildren = "children";
Constants.InputContextMenuCommandSurface = "ContextMenu";
Constants.InputContextMenuText = "ContextMenuText";
Constants.InputContextMenuCell = "ContextMenuCell";
Constants.InputControl = "control";
Constants.InputControlType = "controlType";
Constants.InputDescription = "description";
Constants.InputDescriptionResId = "descriptionResId";
Constants.InputDesktopFormFactor = "DesktopFormFactor";
Constants.InputDesktopSettings = "DesktopSettings";
Constants.InputDocument = "Document";
Constants.InputEnabled = "enabled";
Constants.InputEvents = "events";
Constants.InputExecuteFunction = "ExecuteFunction";
Constants.InputFixedControl = "fixedControl";
Constants.InputFunctionFileResid = "_functionFileResid";
Constants.InputFunctionName = "functionName";
Constants.InputGetStartedNode = "_getStartedNode";
Constants.InputGroup = "group";
Constants.InputIcon = "icon";
Constants.InputIconResId = "iconResId";
Constants.InputId = "id";
Constants.InputImages = "images";
Constants.InputLabel = "label";
Constants.InputLabelResId = "labelResId";
Constants.InputLaunchEvent = "LaunchEvent";
Constants.InputLearnMoreUrl = "learnMoreUrl";
Constants.InputMailHost = "MailHost";
Constants.InputMeetingDetailsOrganizer = "";
Constants.InputMenu = "Menu";
Constants.InputMenuItem = "MenuItem";
Constants.InputMessageComposeCommandSurface = "MessageComposeCommandSurface";
Constants.InputMessageReadCommandSurface = "MessageReadCommandSurface";
Constants.InputMobileAppointmentAttendeeCommandSurface = "MobileAppointmentAttendeeCommandSurface";
Constants.InputMobileAppointmentOrganizerCommandSurface = "MobileAppointmentOrganizerCommandSurface";
Constants.InputMobileLogEventAppointmentAttendee = "MobileLogEventAppointmentAttendee";
Constants.InputMobileMessageComposeCommandSurface = "MobileMessageComposeCommandSurface";
Constants.InputMobileMessageReadCommandSurface = "MobileMessageReadCommandSurface";
Constants.InputMobileOnlineMeetingCommandSurface = "MobileOnlineMeetingCommandSurface";
Constants.InputMobileFormFactor = "MobileFormFactor";
Constants.InputOptions = "options";
Constants.InputOverridenByRibbonApi = "overridenByRibbonApi";
Constants.InputPosition = "position";
Constants.InputPresentation = "Presentation";
Constants.InputPrimaryCommandSurface = "PrimaryCommandSurface";
Constants.InputRequirements = "_requirements";
Constants.InputReportPhishingCommandSurface = "ReportPhishingCommandSurface";
Constants.InputResid = "resid";
Constants.InputScale = "scale";
Constants.InputSendMode = "sendMode";
Constants.InputSendModeBlock = "block";
Constants.InputSendModePromptUser = "promptuser";
Constants.InputSendModeSoftBlock = "softblock";
Constants.InputSets = "sets";
Constants.InputSize = "size";
Constants.InputShowTaskpane = "ShowTaskpane";
Constants.InputSourceLocation = "sourceLocation";
Constants.InputSourceLocationResid = "sourceLocationResid";
Constants.InputSpamFreeTextSectionLabelResId = "spamFreeTextSectionLabelResId";
Constants.InputSpamMoreInfo = "spamMoreInfo";
Constants.InputSpamPreProcessingDialog = "spamPreProcessingDialog";
Constants.InputSpamReportingOptions = "spamReportingOptions";
Constants.InputSupertip = "superTip";
Constants.InputTabletFormFactor = "TabletFormFactor";
Constants.InputTabs = "tabs";
Constants.InputTaskpaneId = "taskpaneId";
Constants.InputTextResId = "textResId";
Constants.InputPinnable = "pinnable";
Constants.InputTitle = "title";
Constants.InputTitleResId = "titleResId";
Constants.InputType = "type";
Constants.InputUrlResId = "urlResId";
Constants.InputWorkbook = "Workbook";
Constants.InputMailBoxCapability = "Mailbox";
Constants.InputAddinCommandCapability = "AddinCommands";
Constants.LegacyMailAppIconSize = 64;
Constants.LegacyWXPAppIconSize = 32;
Constants.LegacyMailAppHighResolutionIconSize = 128;
Constants.LegacyWXPAppHighResolutionIconSize = 64;
Constants.DeveloperPrivacyUrl = "developer.privacyUrl";
Constants.DeveloperTermsOfUseUrl = "developer.termsOfUseUrl";
Constants.DeveloperWebSiteUrl = "developer.websiteUrl";
Constants.ExtensionAudienceClaimUrl = "extensions[0].audienceClaimUrl";
Constants.IconsColor = "icons.color";
Constants.IconsOutline = "icons.outline";
Constants.MosDescriptionFull = "description.full";
Constants.MosDescriptionShort = "description.short";
Constants.MosCode = "code";
Constants.MosId = "id";
Constants.MosNameFull = "name.full";
Constants.MosNameShort = "name.short";
Constants.MosRequirements = "requirements";
Constants.AlternatesHighResolutionIconUrl = "extensions[0].alternates[%d].alternateIcons.highResolutionIcon.url";
Constants.AlternatesIconUrl = "extensions[0].alternates[%d].alternateIcons.icon.url";
Constants.RibbonsFixedControlsLabel = "extensions[0].ribbons[%d].fixedControls[%d].label";
Constants.RibbonsFixedControlsIconsUrl = "extensions[0].ribbons[%d].fixedControls[%d].icons[%d].url";
Constants.RibbonsFixedControlsSuperTipDescription = "extensions[0].ribbons[%d].fixedControls[%d].supertip.description";
Constants.RibbonsFixedControlsSuperTipTitle = "extensions[0].ribbons[%d].fixedControls[%d].supertip.title";
Constants.RibbonsSpamProcessingDialogDescription = "extensions[0].ribbons[%d].spamPreProcessingDialog.description";
Constants.RibbonsSpamProcessingDialogSpamFreeTextSectionLabel = "extensions[0].ribbons[%d].spamPreProcessingDialog.spamFreeTextSectionLabel";
Constants.RibbonsSpamProcessingDialogTitle = "extensions[0].ribbons[%d].spamPreProcessingDialog.title";
Constants.RibbonsSpamProcessingDialogSpamMoreInfoText = "extensions[0].ribbons[%d].spamPreProcessingDialog.spamMoreInfo.text";
Constants.RibbonsSpamProcessingDialogSpamMoreInfoUrl = "extensions[0].ribbons[%d].spamPreProcessingDialog.spamMoreInfo.url";
Constants.RibbonsSpamProcessingDialogSpamReportingOptionsTitle = "extensions[0].ribbons[%d].spamPreProcessingDialog.spamReportingOptions.title";
Constants.RibbonsSpamProcessingDialogSpamReportingOptionsOptions = "extensions[0].ribbons[%d].spamPreProcessingDialog.spamReportingOptions.options[%d]";
Constants.RibbonsTabsLabel = "extensions[0].ribbons[%d].tabs[%d].label";
Constants.RibbonsTabsCustomMobileRibbonGroupsLabel = "extensions[0].ribbons[%d].tabs[%d].customMobileRibbonGroups[%d].label";
Constants.RibbonsTabsCustomMobileRibbonGroupsControlsLabel = "extensions[0].ribbons[%d].tabs[%d].customMobileRibbonGroups[%d].controls[%d].label";
Constants.RibbonsTabsCustomMobileRibbonGroupsControlsIconsUrl = "extensions[0].ribbons[%d].tabs[%d].customMobileRibbonGroups[%d].controls[%d].icons[%d].url";
Constants.RibbonsTabsGroupsIconsFile = "extensions[0].ribbons[%d].tabs[%d].groups[%d].icons[%d].file";
Constants.RibbonsTabsGroupsIconsUrl = "extensions[0].ribbons[%d].tabs[%d].groups[%d].icons[%d].url";
Constants.RibbonsTabsGroupsLabel = "extensions[0].ribbons[%d].tabs[%d].groups[%d].label";
Constants.RibbonsTabsGroupsControlsIconsFile = "extensions[0].ribbons[%d].tabs[%d].groups[%d].controls[%d].icons[%d].file";
Constants.RibbonsTabsGroupsControlsIconsUrl = "extensions[0].ribbons[%d].tabs[%d].groups[%d].controls[%d].icons[%d].url";
Constants.RibbonsTabsGroupsControlsLabel = "extensions[0].ribbons[%d].tabs[%d].groups[%d].controls[%d].label";
Constants.RibbonsTabsGroupsControlsSupertipTitle = "extensions[0].ribbons[%d].tabs[%d].groups[%d].controls[%d].supertip.title";
Constants.RibbonsTabsGroupsControlsSupertipDescription = "extensions[0].ribbons[%d].tabs[%d].groups[%d].controls[%d].supertip.description";
Constants.RibbonsTabsGroupsControlsItemsIconsFile = "extensions[0].ribbons[%d].tabs[%d].groups[%d].controls[%d].items[%d].icons[%d].file";
Constants.RibbonsTabsGroupsControlsItemsIconsUrl = "extensions[0].ribbons[%d].tabs[%d].groups[%d].controls[%d].items[%d].icons[%d].url";
Constants.RibbonsTabsGroupsControlsItemsLabel = "extensions[0].ribbons[%d].tabs[%d].groups[%d].controls[%d].items[%d].label";
Constants.RibbonsTabsGroupsControlsItemsSupertipTitle = "extensions[0].ribbons[%d].tabs[%d].groups[%d].controls[%d].items[%d].supertip.title";
Constants.RibbonsTabsGroupsControlsItemsSupertipDescription = "extensions[0].ribbons[%d].tabs[%d].groups[%d].controls[%d].items[%d].supertip.description";
Constants.ContextMenusMenusControlsIconsFile = "extensions[0].contextMenus[%d].menus[%d].controls[%d].icons[%d].file";
Constants.ContextMenusMenusControlsIconsUrl = "extensions[0].contextMenus[%d].menus[%d].controls[%d].icons[%d].url";
Constants.ContextMenusMenusControlsLabel = "extensions[0].contextMenus[%d].menus[%d].controls[%d].label";
Constants.ContextMenusMenusControlsSupertipTitle = "extensions[0].contextMenus[%d].menus[%d].controls[%d].supertip.title";
Constants.ContextMenusMenusControlsSupertipDescription = "extensions[0].contextMenus[%d].menus[%d].controls[%d].supertip.description";
Constants.ContextMenusMenusControlsItemsIconsFile = "extensions[0].contextMenus[%d].menus[%d].controls[%d].items[%d].icons[%d].file";
Constants.ContextMenusMenusControlsItemsIconsUrl = "extensions[0].contextMenus[%d].menus[%d].controls[%d].items[%d].icons[%d].url";
Constants.ContextMenusMenusControlsItemsLabel = "extensions[0].contextMenus[%d].menus[%d].controls[%d].items[%d].label";
Constants.ContextMenusMenusControlsItemsSupertipTitle = "extensions[0].contextMenus[%d].menus[%d].controls[%d].items[%d].supertip.title";
Constants.ContextMenusMenusControlsItemsSupertipDescription = "extensions[0].contextMenus[%d].menus[%d].controls[%d].items[%d].supertip.description";
Constants.ContentRuntimesPage = "extensions[0].contentRuntimes[%d].code.page";
Constants.RuntimesPage = "extensions[0].runtimes[%d].code.page";
Constants.RuntimesScript = "extensions[0].runtimes[%d].code.script";
Constants.RuntimesActionsDisplayName = "extensions[0].runtimes[%d].actions[%d].displayName";
Constants.DefaultAccessColor = "#230201";
Constants.DefaultDeveloperUrl = "http://localhost/";
Constants.InvalidCharacterInFileName = /[/\\?*:|"<>]/g;
Constants.RuntimeLifetimeShort = "short";
Constants.RuntimeLifetimeLong = "long";
Constants.DefaultOutputFolderName = "temp";
Constants.EllipsisText = "...";
Constants.JSONFileSuffix = ".json";
Constants.JSONManifestFileName = "manifest.json";
Constants.LoggingPrefix = "[CONVERTER]: ";
Constants.LoggingPrefixWarning = "[CONVERTER]: WARNING: ";
Constants.LoggingPrefixError = "[CONVERTER]: ERROR: ";
Constants.MaxResourceStringLengthAny = -1;
Constants.MaxResourceStringLength30 = 30;
Constants.MaxResourceStringLength32 = 32;
Constants.MaxResourceStringLength64 = 64;
Constants.MaxResourceStringLength80 = 80;
Constants.MaxResourceStringLength100 = 100;
Constants.MaxResourceStringLength128 = 128;
Constants.MaxResourceStringLength250 = 250;
Constants.MaxResourceStringLength256 = 256;
Constants.MaxResourceStringLength512 = 512;
Constants.MaxResourceStringLength2048 = 2048;
Constants.MaxResourceStringLength4000 = 4000;
Constants.TruncationText = "<TRUNCATED>";
//# sourceMappingURL=constants.js.map